import React from "react";
import { useTranslation } from "react-i18next";
import { MdExpandLess, MdExpandMore } from "react-icons/md";
import { serviceEntries, servicesOnCount } from "../carrierHelpers";

// The "2 / 3 on" pill that opens a row's services in the carrier and account tables.
const ServicesPill = ({ row, expanded, onToggle }) => {
  const { t } = useTranslation("settings");
  const total = serviceEntries(row).length;
  if (!total) return <span className="text-xs text-ui-text-subtle">{t("carriers.noServices")}</span>;

  const ExpandIcon = expanded ? MdExpandLess : MdExpandMore;
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-expanded={!!expanded}
      className="inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-ui-border bg-ui-surface py-[3px] pl-2.5 pr-1.5 text-xs font-medium text-ui-text-secondary transition-colors hover:border-brand hover:text-brand"
    >
      {t("carriers.servicesPill", { on: servicesOnCount(row), total })}
      <ExpandIcon className="h-4 w-4" />
    </button>
  );
};

export default ServicesPill;
